export default "__VITE_ASSET__DqKvOuZ$__"